// Author: Luis Booth - September 2018
// Do a Barrel Roll!

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'js/components/global/collapsible/Collapsible';
import { InputGroup } from 'react-nice-inputs';
// import DataService from 'js/modules/dataservice';

class CollapsibleWrapper extends PureComponent {

  state = {
    data: {},
    active: this.props.expanded,
    hasBeenOpened: false
  }

  /* eslint-disable */
  componentDidUpdate(prevProps) {

    if(this.props.expanded !== prevProps.expanded) {
      this.setState({ active: this.props.expanded });
    }
  }
  /* eslint-enable */

  // async fetchData(endPointURI) {
  //   const dataServiceResp = await DataService.getAllInfo(endPointURI);

  //   this.setState({data: dataServiceResp});
  // }

  // toggleCollapse = (headersOnClick) => {

  //   return (event) => {

  //     const { active, hasBeenOpened } = this.state;

  //     !hasBeenOpened && this.setState({hasBeenOpened: true});
  //     // !hasBeenOpened && this.fetchData(this.props.fetchEndpoint);

  //     if (typeof headersOnClick === 'function') {
  //       headersOnClick(event);
  //     }

  //     // !hasBeenOpened && this.props.onToggle(event);
  //     this.props.onToggle(event);

  //     active && this.props.onClose();

  //     this.setState({
  //       active: !active,
  //     });
  //   };
  // }

  toggleCollapse = (headersOnClick) => {

    if (typeof headersOnClick === 'function') {

      return event => {
        headersOnClick(event);

        this.setState({
          active: !this.state.active,
        });
      };

    }

    return (value, name, event) => {

      const { hasBeenOpened, active } = this.state;

      !hasBeenOpened && this.setState({hasBeenOpened: true});

      this.props.onToggle(event, value);

      active && this.props.onClose();

      this.setState({
        [name]: [value],
        active: !active,
      });
    };
  }

  render() {

    const { active } = this.state;
    const props = {...this.props};

    const header = this.props.header ? (
      React.cloneElement(
        this.props.header,
        {
          ...this.props.header.props,
          onClick: this.toggleCollapse(this.props.header.props.onClick)
        }
      )
    ) : (
      <InputGroup
        type="checkbox"
        onChange={this.toggleCollapse()}
        {...props.inputProps}
      />
    );

    return (
      <Collapsible expanded={active} title={header} classList={props.classList} animated={props.animated}>
        {this.props.children}
      </Collapsible>
    );
  }
}


CollapsibleWrapper.propTypes = {
  classList: PropTypes.array,
  onToggle: PropTypes.func,
  expanded: PropTypes.bool,
  fetchEndpoint: PropTypes.string,
  onClose: PropTypes.func,
  animated: PropTypes.bool
};

CollapsibleWrapper.defaultProps = {
  classList: [],
  expanded: false,
  onToggle: () => {},
  onClose: () => {},
  animated: false,
};

export default CollapsibleWrapper;



// WEBPACK FOOTER //
// ./js/components/global/collapsible/CollapsibleWrapper.js